import { log } from '@/log'
import { DataLayerService } from '@/vendor/gtm/data-layer'
import { gpPromotionContextEventFactory } from '@/vendor/gtm/events/gp/promotion-context'
import {
  DefaultPromotionContextRepository,
  PromotionContextRepository,
} from './repository'

export class PromotionContextDataLayerPublisher {
  static createDefault(): PromotionContextDataLayerPublisher {
    return new PromotionContextDataLayerPublisher()
  }

  private publishPromise: Promise<void> | null = null

  constructor(
    private readonly repository: PromotionContextRepository = DefaultPromotionContextRepository.createDefault(),
    private readonly dataLayerService: DataLayerService = new DataLayerService()
  ) {}

  publish(): Promise<void> {
    if (this.publishPromise !== null) {
      return this.publishPromise
    }

    this.publishPromise = this.innerPublish()

    return this.publishPromise
  }

  private async innerPublish(): Promise<void> {
    try {
      const result = await this.repository.get()

      result.fold(
        error => log.error('Failed to publish promotion context', error),
        context => this.dataLayerService.push(gpPromotionContextEventFactory.create(context))
      )
    } catch (error) {
      log.error('Unexpected error while publishing promotion context', error)
    }
  }
}

const defaultPublisher = PromotionContextDataLayerPublisher.createDefault()

export function publishPromotionContext(): Promise<void> {
  return defaultPublisher.publish()
}
